import { css } from '@repo/pandacss/css';

export const baseRowClass = css({
  display: 'flex',
  alignItems: 'center',
  gap: '2',
  py: '1',
  px: '2',
  minH: '[52px]',
  rounded: 'md',
  border: '[1px solid {colors.neutral.lighter}]',
  bg: 'common.white',
  cursor: 'pointer',
  width: '[100%]',
  textAlign: 'left',
  color: 'neutral.darkest',
  textStyle: 'body',
  transition: '[border-color 150ms, background-color 150ms]',
  position: 'relative',
  _hover: { borderColor: 'blues.focus' },
  '&:has(:focus-visible)': {
    outline: '[2px solid {colors.blues.focus}]',
    outlineOffset: '[-2px]',
  },
  '&:has(:disabled)': { opacity: '[0.5]', cursor: 'not-allowed' },
});

export const selectedRowClass = css({
  borderColor: 'blues.focus',
  bg: 'blues.extraLight',
});
